import Model from './model';
import Scene from './scene';
import {
  Vector3,
  Object3D,
  Color,
} from 'three';


const TModel = {
  Model,
  Scene,
  Vector3,
  Object3D,
  Color,
};


export default TModel;
